<template>
  <SrpModal v-model:isVisible="_isVisible" :isClosable="false" @close="emit('close')">
    <template #header>
      <h2 class="global-h2">Upload your Photos</h2>
    </template>

    <template #content>
      <div style="margin: 10px 0">
        <UploadPhotosNonAdventure
          :customerId="customerId"
          :autoCloseAfterUpload="autoCloseAfterUpload"
          @imageAddedToGallery="imageServerId => emit('imageAddedToGallery', imageServerId)"
          @imageUploadedToServer="({ serverId }) => emit('imageUploadedToServer', serverId)"
          @uploadComplete="uploadComplete"
          @uploadProgressChange="_isUploadInProgress => (isUploadingInProgress = _isUploadInProgress)"
          @error="
            () => {
              isUploadingInProgress = false;
              emit('error');
            }
          "
          :isAddImagesToGallery="props.isAddImagesToGallery"
          :style="{
            opacity: isUploadingInProgress ? '0.5' : 1,
            pointerEvents: isUploadingInProgress ? 'none' : 'auto',
          }"
        />
      </div>
    </template>

    <template #footer>
      <SrpButton @click="uploadComplete" :isDisabled="isUploadingInProgress" fill="outlined">
        {{ isUploadingInProgress ? "Uploading..." : "Done" }}
      </SrpButton>
    </template>
  </SrpModal>

  <slot name="trigger" :openModal="() => (_isVisible = true)">
    <button :class="buttonClasses" @click="_isVisible = true">Upload your Photos</button>
  </slot>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import UploadPhotosNonAdventure from "./UploadPhotosNonAdventure.vue";

const props = withDefaults(
  defineProps<{
    customerId: string;
    buttonClasses?: string;
    autoCloseAfterUpload?: boolean;
    isAddImagesToGallery?: boolean;
  }>(),
  {
    customerId: "",
    buttonClasses: "",
    autoCloseAfterUpload: true,
    isAddImagesToGallery: true,
  }
);

const emit = defineEmits<{
  (e: "imageAddedToGallery", imageServerId: string): void;
  (e: "imageUploadedToServer", imageServerId: string): void;
  (e: "uploadComplete"): void;
  (e: "error"): void;
  (e: "close"): void;
}>();

// Local isVisible ============================================================
const _isVisible = ref<boolean>(false);

// Is Uploading in progress ===================================================
const isUploadingInProgress = ref<boolean>(false);

function uploadComplete() {
  emit("uploadComplete");

  _isVisible.value = false;
}
</script>
